// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__3HphQ","loaderOuter":"PageOverlayLoader_loaderOuter__2Smvv"};